<div id="actions-container" *ngIf="this.value.action == 'email'">
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityAction != 0">
    Se enviarán por email
    <strong> {{ this.value.quantityAction }}</strong> facturas emitidas.
  </p>
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityWrong != 0">
    <strong>{{ this.value.quantityWrong }}</strong> no cumplen las condiciones
    porque no tienen CAE generado.
  </p>
  <mat-checkbox
    [checked]="this.emailCheck"
    color="primary"
    id="check"
    (change)="checkboxChange($event.checked)"
  >
    <p class="subheading-01-semi-bold">¿Desea recibir una copia por email?</p>
  </mat-checkbox>
</div>

<div id="actions-container" *ngIf="this.value.action == 'cae'">
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityAction != 0">
    Se van a solicitar a la AFIP
    <strong> {{ this.value.quantityAction }}</strong> comprobantes que se
    encontraban guardados como borrador.
  </p>
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityWrong != 0">
    <strong>{{ this.value.quantityWrong }}</strong> no cumplen las condiciones
    para solicitar CAE y serán desestimados en la solicitud.
  </p>
</div>

<div id="actions-container" *ngIf="this.value.action == 'delete'">
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityAction != 0">
    Se van a eliminar
    <strong> {{ this.value.quantityAction }}</strong> comprobantes.
  </p>
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityWrong != 0">
    <strong>{{ this.value.quantityWrong }}</strong> no cumplen las condiciones
    para ser eliminados y serán desestimados en la solicitud.
  </p>
</div>

<div id="actions-container" *ngIf="this.value.action == 'download'">
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityAction != 0">
    Se van a descargar
    <strong> {{ this.value.quantityAction }}</strong> facturas emitidas.
  </p>
  <p class="subheading-01-semi-bold" *ngIf="this.value.quantityWrong != 0">
    <strong>{{ this.value.quantityWrong }}</strong> no cumplen las condiciones
    para ser descargados ya que no poseen CAE generado y serán desestimadas en
    la solicitud.
  </p>
</div>
